import { Link } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"

const DOWNLOAD_TEMPLATE_PATH = "/admin/invoices/bulk_send_invoices_upload_template"

export const InvoiceDownloadBulkSendInvoicesUploadTemplate = () => {
  const { t } = useTranslation("Invoices")

  return (
    <Link to={DOWNLOAD_TEMPLATE_PATH} className="text-sm" download target="_blank">
      {t("uploadBulkSendInvoices.downloadTemplate")}
    </Link>
  )
}
